import {DELETE_BUCKET} from 'recommendations/redux';
import {
  RecommendedCollege,
  TARGET_ME_KEY,
  GetBucketResponse,
  RECOMMENDATION_BUCKET_FIELDS,
} from 'src/services/RecommendationsService';
import {getColleges} from 'shared/actions/college';
import {formatCollege} from 'src/utils/collegeSearch';
import {keyBy} from 'lodash';
import {recommendationsLoaded} from './recommendations';
import SponsoredRecommendationsService, {
  SponsoredRecommendation,
} from 'src/services/SponsoredRecommendationsService';

function joinCollegesAndCampaigns(
  colleges: $TSFixMe,
  campaigns: SponsoredRecommendation[]
): RecommendedCollege[] {
  const collegeIdToRecommendation = keyBy(campaigns, 'collegeId');

  return colleges.map((college: $TSFixMe) =>
    Object.assign(
      {campaignId: collegeIdToRecommendation[college._id].campaignId},
      formatCollege(college)
    )
  );
}

export const sponsoredRecommendationBucket: GetBucketResponse = {
  definition: 'These colleges are looking at students with a portfolio like yours',
  category: 'sponsored',
  short: 'Interested colleges',
  because: 'Colleges interested in students like you',
  id: TARGET_ME_KEY,
};

export function getSponsoredRecommendations(limit: number) {
  return async (dispatch: $TSFixMe): Promise<{type: string}> => {
    let campaigns: SponsoredRecommendation[] = [];

    try {
      campaigns = await SponsoredRecommendationsService.index({limit});
    } catch (error) {
      console.error('Error fetching campaigns', error);
      return dispatch({type: DELETE_BUCKET, id: TARGET_ME_KEY});
    }

    if (campaigns.length === 0) {
      return dispatch({type: DELETE_BUCKET, id: TARGET_ME_KEY});
    }

    const collegeIds = campaigns.map((campaign) => campaign.collegeId).join(',');
    let colleges;
    try {
      colleges = await getColleges(collegeIds, RECOMMENDATION_BUCKET_FIELDS.join(','));
    } catch (error) {
      console.error('Error fetching colleges', error);
      return dispatch({type: DELETE_BUCKET, id: TARGET_ME_KEY});
    }

    const recommendedColleges = joinCollegesAndCampaigns(colleges, campaigns);
    return dispatch(recommendationsLoaded(TARGET_ME_KEY, recommendedColleges));
  };
}
